import { useState } from "react";
import axios from "axios";
import { Lock, Loader2 } from "lucide-react";
import { LogoMark } from "../Logo";
import { API, formatErr } from "../../lib/api";

export const AdminLogin = ({ onSuccess }) => {
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError("");
    try {
      const { data } = await axios.post(`${API}/admin/login`, { password });
      sessionStorage.setItem("rt_admin", data?.token ?? "");
      onSuccess();
    } catch (err) {
      setError(formatErr(err.response?.data?.detail) || "Log masuk gagal");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen grid place-items-center px-5 grid-bg">
      <form onSubmit={submit} className="glass rounded-3xl p-8 sm:p-10 w-full max-w-sm" data-testid="admin-login-form">
        <LogoMark className="w-12 h-12 mb-6" />
        <h1 className="font-display uppercase font-black text-2xl">Admin Panel</h1>
        <p className="text-sm text-violet-100/75 mt-1 mb-8">Masukkan kata laluan admin.</p>
        <div className="flex items-center gap-3 border-b-2 border-violet-400/30 focus-within:border-violet-300 transition-colors">
          <Lock className="w-4 h-4 text-violet-300" />
          <input
            type="password"
            required
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            placeholder="Kata laluan"
            data-testid="admin-password-input"
            className="flex-1 bg-transparent outline-none py-3 text-white placeholder:text-violet-200/40"
          />
        </div>
        {error && <p className="text-sm text-pink-300 mt-3" data-testid="admin-login-error">{error}</p>}
        <button type="submit" disabled={loading} data-testid="admin-login-btn" className="btn-neon w-full rounded-full py-3 mt-8 font-semibold inline-flex justify-center">
          {loading ? <Loader2 className="w-5 h-5 animate-spin" /> : "Log Masuk"}
        </button>
      </form>
    </div>
  );
};
